module.exports = __webpack_public_path__ + "img/4@2x.1e6cc631.png";